import './hover-details.scss';

import classNames from 'classnames';
import kebabCase from 'lodash/kebabCase';
import { object, string } from 'prop-types';
import React from 'react';
import { PopoverBody, UncontrolledPopover } from 'reactstrap';

import { linkRefShape } from '../../prop-types';

function HoverDetails({ linkRef, size, title, fields, className }) {
  return (
    <UncontrolledPopover
      className={classNames(`popover-container-${size}`, className)}
      trigger="hover"
      placement="right"
      target={linkRef}
    >
      <PopoverBody>
        <h6 className="mb-3 font-size-medium">{title}</h6>
        <dl className="row font-size-small text-muted mb-0">
          {Object.entries(fields).map(([name, field]) => (
            <React.Fragment key={name}>
              <dt className="col-5" name={`${kebabCase(name)}-key`}>
                {name}
              </dt>
              <dd className="col-7" name={`${kebabCase(name)}-value`}>
                {field || '-'}
              </dd>
            </React.Fragment>
          ))}
        </dl>
      </PopoverBody>
    </UncontrolledPopover>
  );
}

HoverDetails.propTypes = {
  title: string.isRequired,
  className: string,
  size: string,
  linkRef: linkRefShape.isRequired,
  fields: object.isRequired, // eslint-disable-line react/forbid-prop-types
};

HoverDetails.defaultProps = {
  size: 'medium',
  className: '',
};

export default HoverDetails;
